import React from "react";

const OurFootprints = () => {
  return (
    <div className=" p-6 ">
      <div className="text-center max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-6 text-gray-800">
          Our Global Impact
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mb-10">
          Providing exceptional services through innovative solutions that cater
          to our clients' needs around the world.
        </p>

        <div className="grid grid-cols-21 md:grid-cols-2 gap-2">
          <div className="text-center">
            <img
              src="/assets/flag/ind.png"
              alt="India"
              className="w-60 mx-auto mb-4"
            />
            <h3 className="font-bold text-xl mr-6">INDIA</h3>
            <p>E-155, E Block, Sector 63, Noida, Uttar Pradesh 201301.</p>
            <p className="font-bold mt-2">+91-8802319226</p>
          </div>
          <div className="text-center">
            <img
              src="/assets/flag/usa.png"
              alt="USA"
              className="w-60 mx-auto mb-4"
            />
            <h3 className="font-bold text-xl">USA</h3>
            <p></p>
            <p className="font-bold mt-2">+1-917-283-4232</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurFootprints;
